<template>
    <div class="swiperwrapimg" v-finger:swipe="touchswipe" @mouseover="stop=true" @mouseout="stop=false">
        <ul class="swiperbg">
            <li v-for="(item,index) in infolist" :key="index" :style="{width:itemwidth}">
                <img :src=" typeof item == 'object'?item.img:item" class="swiperimg" />
            </li>
        </ul>
        <ul class="swiperbox">
            <li v-for="(item,index) in c_infolist" :key="index" :style="{width:itemwidth}" :class="[mv==0?'swiperhorsewait':direct == 1 ?'swiperhorseleft':'swiperhorseright']">
                <img :src="typeof item == 'object'?item.img:item" class="swiperimg" />
            </li>
        </ul>
    </div>

</template>

<script>
    export default {
        name: 'ffswiperimg',
        data() {
            return {
                indexcur: 0,
                direct: 1,
                mv: 0,
                stop: false,
                myinterval: '',
                optionsdefault: { 'isautoplay': true, 'duration': 3000 }
            }

        },
        props: {
            infolist: {
                type: Array,
                default: () => []
            },
            options: {
                type: Object,
                default: () => { }
            },
            step: {
                type: Number,
                default: 1
            }
        },
        computed: {
            c_options: function () {
                return Object.assign({}, this.optionsdefault, this.options);
            },
            itemmax: function () {
                return this.infolist.length;
            },
            c_infolist: function () {
                let _infolist = [];
                for (var i = 0; i <= this.step + 1; i++) {
                    let ii = this.indexcur - 1 + i;
                    ii = ii < 0 ? this.itemmax + ii : ii >= this.itemmax ? ii - this.itemmax : ii;
                    _infolist.push(this.$common.basic.jsonclone(this.infolist[ii]));
                }
                return _infolist;
            },
            itemwidth: function () {
                let _itemwidth = Math.round(1000 / this.step) / 10;

                return _itemwidth + "%";
            }
        },
        methods: {
            autoplay: function () {
                if (this.c_options.isautoplay) {
                    let vm = this;
                    this.myinterval = window.setInterval(function () {
                        if (!vm.stop) {
                            vm.goplay();
                        }
                    }, vm.c_options.duration);
                }
            },
            touchswipe: function (e) {
                if (e.direction == "Left") {
                    this.gonext();
                }
                else {
                    if (e.direction == "Right") {
                        this.goprev();
                    }
                }
            },
            gonext: function () {
                this.goplay(1);
            },
            goprev: function () {
                this.goplay(2);
            },
            goplay: function (direct) {
                if (this.mv == 0) {
                    this.mv = 1;
                    if (direct) {
                        this.direct = direct;
                    }
                    this.$nextTick(() => {
                        window.setTimeout(() => {
                            this.afterenter();
                        }, 1500);
                    })

                }
            },
            afterenter: function () {

                if (this.mv == 1) {
                    let nindex = this.indexcur + (this.direct == 1 ? 1 : -1);
                    nindex = nindex < 0 ? this.itemmax + nindex : nindex >= this.itemmax ? nindex - this.itemmax : nindex;
                    this.indexcur = nindex;
                }
                this.mv = 0;
            }
        },
        beforeDestroy() {
            window.clearInterval(this.myinterval);
        },
        mounted() {
            this.autoplay();
        }
    }
</script>
